module.exports = __webpack_public_path__ + "static/media/supportAndMaintenance.deb37e8e.svg";